export default __webpack_public_path__ + "static/media/FICHA TÉCNICA- LIMÃO TAITI.5ee9ee0a.pdf";